import { ref } from 'vue';
import { physicalLocationApi } from '@/entities/Document';
import { extractApiErrorMessage, toastError, toastSuccess, useCustomToast } from '@/shared/lib';

import { documentManagementMessages } from './messages';

interface DeletePhysicalLocationResult {
  success: boolean;
}

export function useDeletePhysicalLocation() {
  const toast = useCustomToast();
  const isDeleting = ref(false);

  async function deletePhysicalLocation(id: number): Promise<DeletePhysicalLocationResult> {
    isDeleting.value = true;

    try {
      await physicalLocationApi.deletePhysicalLocation(id);

      toastSuccess(toast, documentManagementMessages.physicalLocations.deleteSuccessToast);

      return { success: true };
    } catch (error) {
      const serverMessage = extractApiErrorMessage(error);

      if (serverMessage) {
        toastError(
          toast,
          documentManagementMessages.physicalLocations.deleteRefusedToast,
          serverMessage
        );
      } else {
        toastError(toast, documentManagementMessages.physicalLocations.deleteErrorToast);
      }

      return { success: false };
    } finally {
      isDeleting.value = false;
    }
  }

  return {
    isDeleting,
    deletePhysicalLocation,
  };
}
